"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _dateUtils = require("./date-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const DatePicker = ({
  onMonthChange,
  onClosed,
  value,
  onChange,
  onBlur,
  color,
  disabled,
  placeholder,
  name,
  id,
  label,
  labelClassName,
  inputClassName,
  showCalendarIcon,
  className,
  clearable,
  errorMessage,
  required,
  ...rest
}) => {
  var _inputRef$current, _inputRef$current$val, _inputRef$current2, _inputRef$current2$va;

  const inputRef = (0, _react.useRef)();
  const elementRef = (0, _react.useRef)();
  const [showCalendar, setShowCalendar] = (0, _react.useState)(false);
  const [dateState, setDateState] = (0, _react.useState)((0, _dateUtils.getCurrentYearAndMonth)());
  const [monthDetails, setMonthDetails] = (0, _react.useState)((0, _dateUtils.getMonthDetails)(dateState === null || dateState === void 0 ? void 0 : dateState.year, dateState === null || dateState === void 0 ? void 0 : dateState.month));
  const [selectedDay, setSelectedDay] = (0, _react.useState)(_dateUtils.todayTimestamp);
  const [inputValue, setInputValue] = (0, _react.useState)(value || "");

  const addBackDrop = e => {
    if (e.target) {
      var _elementRef$current;

      if (!(elementRef && (_elementRef$current = elementRef.current) !== null && _elementRef$current !== void 0 && _elementRef$current.contains(e.target))) {
        setShowCalendar(false);
        onClosed({
          activeDay: selectedDay,
          isOpened: false,
          clicked: e
        });
      }
    }
  };

  (0, _react.useEffect)(() => {
    document.addEventListener("click", addBackDrop);

    if (isNaN(Date.parse(value)) === false) {
      setDateToInput(value);
    }

    return () => document.removeEventListener("click", addBackDrop);
  }, []);
  (0, _react.useEffect)(() => {
    if (disabled && showCalendar) {
      setShowCalendar(false);
      onClosed();
    } else {
      if (!showCalendar) {
        onClosed();
      }
    }
  }, [showCalendar, disabled]);

  const setYear = offset => {
    let year = dateState.year + offset;
    let month = dateState.month;
    setDateState(prev => ({ ...prev,
      year
    }));
    setMonthDetails((0, _dateUtils.getMonthDetails)(year, dateState.month));
  };

  const setDateToInput = timestamp => {
    const dateString = (0, _dateUtils.getDateStringFromTimestamp)(timestamp);
    inputRef.current.value = dateString;
  };

  const onDateClick = day => {
    setSelectedDay(day.timestamp);
    setInputValue(day.timestamp);

    if (onChange) {
      onChange({
        target: {
          value: day.timestamp
        }
      });
    }
  };

  const setMonth = offset => {
    let year = dateState.year;
    let month = dateState.month + offset;

    if (dateState.month === -1) {
      month = 11;
      year--;
    } else if (dateState.month === 12) {
      month = 0;
      year++;
    }

    setDateState(prev => ({ ...prev,
      month,
      year
    }));
    setMonthDetails((0, _dateUtils.getMonthDetails)(year, month));

    if (onMonthChange) {
      onMonthChange({
        month: getMonthStr(month),
        year,
        selectedDay
      });
    }
  };

  const setDate = value => {
    let selectedDay = new Date(value.year, value.month - 1, value.date).getTime();
    setSelectedDay(selectedDay);

    if (onChange) {
      onChange({
        target: {
          value: selectedDay
        }
      });
    }
  };

  const getDateFromDateString = dateValue => {
    let dateData = dateValue.split("-").map(d => parseInt(d, 10));
    if (dateData.length < 3) return null;
    let year = dateData[0];
    let month = dateData[1];
    let date = dateData[2];
    return {
      year,
      month,
      date
    };
  };

  const updateFormInput = () => {
    let dateValue = inputRef.current.value;
    let dateData = getDateFromDateString(dateValue);

    if (dateData) {
      setDate(dateData);
      setDateState({
        year: dateData.year,
        month: dateData.month - 1,
        monthDetails: (0, _dateUtils.getMonthDetails)(dateData.year, dateData.month - 1)
      });
    }
  };

  const getMonthStr = month => {
    return _dateUtils.monthsMap[Math.max(Math.min(11, month), 0)] || "Month";
  };

  const handleIconClick = () => {
    if (clearable && inputValue) {
      setInputValue("");

      if (onChange) {
        onChange({
          target: {
            value: null
          }
        });
      }

      setShowCalendar(false);
    } else {
      setShowCalendar(!showCalendar);
    }
  };

  const renderCalendar = () => {
    let days = monthDetails.map((day, idx) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `calenlar-day-container ${day.month !== 0 ? "disabled" : ""} ${(0, _dateUtils.isCurrentDay)(day) ? "current-day" : ""} ${(0, _dateUtils.isSelectedDay)(day, selectedDay) ? "selected-day" : ""}`,
        key: idx
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: `day day__${color}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        onClick: () => onDateClick(day)
      }, day.date)));
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "weekday-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "weekday-head"
    }, ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"].map((weekDay, idx) => /*#__PURE__*/_react.default.createElement("div", {
      key: idx,
      className: "weekday-name"
    }, weekDay))), /*#__PURE__*/_react.default.createElement("div", {
      className: "weekday-body"
    }, days));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-datepickr",
    ref: elementRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-datepickr__input",
    onClick: () => !disabled && setShowCalendar(true)
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    className: `spta-label ${labelClassName}`,
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "date",
    disabled: disabled,
    id: id,
    name: name,
    className: `input__date ${required && !((_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && (_inputRef$current$val = _inputRef$current.validity) !== null && _inputRef$current$val !== void 0 && _inputRef$current$val.valid) ? "invalid" : ""} ${className}`,
    onChange: updateFormInput,
    onBlur: onBlur,
    ref: inputRef,
    placeholder: placeholder,
    value: (0, _dateUtils.getDateStringFromTimestamp)(inputValue),
    required: required
  }, rest, {
    autoComplete: "off"
  })), showCalendarIcon && /*#__PURE__*/_react.default.createElement("button", {
    className: "input__btn__icon",
    onClick: handleIconClick
  }, clearable ? inputValue ? /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z"
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 6V5h-3v2h-2V5H9v2H7V5H4v4h16zm0 2H4v8h16v-8zM6 13h5v4H6v-4z"
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 6V5h-3v2h-2V5H9v2H7V5H4v4h16zm0 2H4v8h16v-8zM6 13h5v4H6v-4z"
  }))), required && !((_inputRef$current2 = inputRef.current) !== null && _inputRef$current2 !== void 0 && (_inputRef$current2$va = _inputRef$current2.validity) !== null && _inputRef$current2$va !== void 0 && _inputRef$current2$va.valid) && /*#__PURE__*/_react.default.createElement("small", {
    className: "spta-textarea__error--message"
  }, errorMessage || "This field is required")), showCalendar && /*#__PURE__*/_react.default.createElement("div", {
    className: "sp-datepickr__calendar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-head"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-head__btn"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-inner",
    onClick: () => setMonth(-1)
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "8",
    height: "14",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.82832 7.00023L7.77832 11.9502L6.36432 13.3642L0.000320435 7.00023L6.36432 0.63623L7.77832 2.05023L2.82832 7.00023Z",
    fill: "#3A434B"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-head__middle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "month"
  }, getMonthStr(dateState === null || dateState === void 0 ? void 0 : dateState.month)), "\xA0", /*#__PURE__*/_react.default.createElement("div", {
    className: "year"
  }, dateState === null || dateState === void 0 ? void 0 : dateState.year)), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-head__btn"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-inner",
    onClick: () => setMonth(1)
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "8",
    height: "14",
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.17168 6.99977L0.22168 2.04977L1.63568 0.635769L7.99968 6.99977L1.63568 13.3638L0.22168 11.9498L5.17168 6.99977Z",
    fill: "#3A434B"
  })))))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-body"
  }, renderCalendar())));
};

exports.DatePicker = DatePicker;
DatePicker.propTypes = {
  /**
   * Handles event when date picker input is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Fies event when calender closes
   */
  onClosed: _propTypes.default.func,

  /**
   * Fies event when calender closes
   */
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onMonthChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]),
  color: _propTypes.default.oneOf(_utils.enums.colors),
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  showCalendarIcon: _propTypes.default.bool,
  clearable: _propTypes.default.bool,
  className: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  required: _propTypes.default.bool
};
DatePicker.defaultProps = {
  onFocus: () => {},
  value: undefined,
  onClosed: () => {},
  onChange: () => {},
  onMonthChange: () => {},
  onBlur: () => {},
  color: "blue",
  disabled: false,
  placeholder: "",
  label: "",
  labelClassName: "",
  name: "",
  id: "",
  inputClassName: "",
  required: false,
  className: ""
};
var _default = DatePicker;
exports.default = _default;